import React, { Component, useEffect } from 'react';
import { useState } from 'react';
import "./tabs.scss"
import PropTypes from 'prop-types';

const Tabs = ({ onChange, options, value }) => {

  const [optionsState, setOptionsState] = useState(options || [])
  const [valueState, setValueState] = useState(null)

  useEffect(() => {
    if (options?.length > 0 && value) {
      let optionSelect = options?.find((op) => op?.value == value)
      setValueState(optionSelect?.value)
    }
  }, [options, value])

  const onChangeTab = (tab) => (e) => {
    onChange && onChange(tab?.value)
    setValueState(tab?.value)
  }

  return (
    <div className='tabsCpn'>
      <div className='tabsHeader'>
        {
          optionsState?.map((tab, idx) => {
            return (
              <div
                onClick={onChangeTab(tab)}
                key={idx}
                className='tab'
              >
                <div className={(tab?.value == valueState) ? 'tabContent tabContentSelect' : 'tabContent'}>
                  {tab?.name}
                </div>

              </div>
            )
          })
        }
      </div>
    </div>
  )
}
Tabs.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array
}
export default Tabs;
